import { useEffect, useState } from "react";
import footerImage from "../../../footerImage.png"
import headerImage from "../../../headerFullImage.png"
import "../orderPDF/OrderPDFNewCommonStyleSheet.scss";
import FetchData, { GetOne, GetListAsync } from "../../../providers/dataProvider";
import { useLocation } from "react-router-dom";
import { formatDate, numberToWords, FormatValueDecimal, getStorageData, ConvertFromBase } from "../../../utils/Validate";
import urls from "../../../constants";
import moment from "moment";
import NewTermsAndConditions from "./NewTermsAndConditions";

const OrderPDFNewDetail = () => {
    const location = useLocation();
    const [orderPDFDetails, setOrderPDFDetails] = useState(null);
    const [customerObj, setCustomer] = useState(null);
    const [projectObj, setProject] = useState(null);
    const [listData, setListData] = useState([]);
    const [markDetails, setMarkDetails] = useState([]);
    const [markData, setMarkData] = useState(null);
    const [configData, setConfigData] = useState(null);
    const [variantData, setVariantData] = useState([]);
    const [distributorImage, setDistributorImage] = useState(null);

    const queryParams = new URLSearchParams(location.search);
    const quoteId = queryParams.get("id");

    const { data: currencyList } = FetchData("currency");
    const { data: assignedEngineerList } = FetchData("userprofile");
    const { data: deliveryTermsList } = FetchData("deliveryterms");
    const { data: paymentTermsList } = FetchData("paymentterms");
    const { data: countryList } = FetchData("country");
    const { data: distributorList } = FetchData("distributor");

    const displayDetails = orderPDFDetails?.data;
    const salesEngObj = assignedEngineerList?.find((ob) => ob?.identityId == displayDetails?.salesEngineerId)
    const currencyDetail = currencyList?.find(item => item?.id === displayDetails?.currencyId)

    const orderDistributor = distributorList?.find(item => item?.id === displayDetails?.distributorId);
    const baseCurrency = currencyList?.find(item => item?.id === orderDistributor?.currencyId);

    const CurrencyConvertion = (amount, rate, currency) =>
        ConvertFromBase(amount, rate, currency, baseCurrency);
    

    useEffect(() => {
        if (quoteId) {
            GetOne("order", { id: quoteId }, setOrderPDFDetails);
        }
    }, [quoteId]);

    useEffect(() => {
        if (displayDetails) {
            GetOne("Customer", { id: displayDetails?.customerId }, setCustomer);
            GetOne("project", { id: displayDetails?.projectId }, setProject);
        }
    }, [displayDetails])

    useEffect(() => {
        if (salesEngObj?.id) {
            GetOne("userprofile", { id: salesEngObj?.id }, setListData)
        }
    }, [salesEngObj]);

    useEffect(() => {
        const fetchProductData = async () => {
            const orderProducts = orderPDFDetails?.data?.products;

            if (orderProducts?.length > 0) {
                try {
                    const configDataPromises = orderProducts.map(item =>
                        GetListAsync("productsspecification", { id: item?.productId })
                    );

                    const configDataResults = await Promise.all(configDataPromises);
                    const configResult = configDataResults.filter(result => result?.message === "success")?.map((item) => [...item?.data])?.flat();
                    const VariantPromises = orderProducts.map(item =>
                        GetListAsync("productsvariants", { id: item?.groupId }).then(result => ({
                            markId: item.id,
                            result,
                        }))
                    );

                    const VariantDataResult = await Promise.all(VariantPromises);
                    const variantResult = VariantDataResult.filter(result => result?.result?.message === "success");
                    setVariantData(variantResult)
                    setMarkData(orderProducts);
                    setConfigData(configResult);

                    GetMarkDetails(orderProducts, configResult);
                } catch (error) {
                    console.error("Error fetching product data", error);
                }
            }
        };

        fetchProductData();
    }, [orderPDFDetails]);

    const GetMarkDetails = (markResult, configResult) => {
        if (markResult?.length > 0) {
            let arrayMark = [];
            markResult?.map((item, index) => {
                const productFilterObj = configResult?.filter((config) => config?.productId === item?.productId)
                let arrayAttribute = [];
                item?.productSpecifications?.map((spec) => {
                    const findAttribute = productFilterObj?.map((productItem) => productItem?.productSpecMaps)?.flat().filter(specItem => specItem?.attributeId === spec?.specificationId)
                    const findvalue = findAttribute?.[0]?.productSpecValueMaps?.filter(valuemap => valuemap?.id === spec?.specificationValueId)
                    arrayAttribute.push({ ...spec, attributeName: findAttribute?.[0]?.attributeName, attributeValue: findvalue?.[0]?.valueName })
                })
                arrayMark?.push({ ...item, productSpecifications: arrayAttribute })
            })
            setMarkDetails(arrayMark)
        }
    }

    // Utility function to split array into chunks of four
    const chunkArray = (array, chunkSize) => {
        const result = [];
        for (let i = 0; i < array.length; i += chunkSize) {
            result.push(array.slice(i, i + chunkSize));
        }
        return result;
    };

    // Inside your render or return function
    const renderSpecifications = (mark) => {
        const specChunks = chunkArray(mark?.productSpecifications, 2);
        return specChunks.map((specChunk, rowIndex) => {
            return (
                <tr>
                    {specChunk.map((specification, specIndex) => (
                        <td colSpan="4" className="white-space-nowrap">
                            <span>{specification?.attributeName}{" : "}</span>
                            {specification?.specialValue ? specification?.specialValue : specification?.attributeValue}
                        </td>
                    ))}
                </tr>
            );
        });
    };

    const getVariantValue = (variantId, prodItem) =>
        prodItem?.productItemVariants?.find(filterItem => variantId.includes(filterItem?.variantId))?.variantValue || "";

    const renderProductHeading = (mark) => {
        let dimensions = "";
        if (urls?.LENGTH_NO_OF_SLOTS_GROUP.includes(mark?.groupId)) {
            if (urls?.LENGTH1_LENGTH2_SLOTS_PRODUCT.includes(mark?.productSubGroupId))
                dimensions = `Size ~ <br/> L1 x L2 x Slot`;
            else
                dimensions = `Size ~ <br/> L x Slot x EndCaps`;
        }
        else if (urls?.LENGTH_HEIGHT_GROUP.includes(mark?.groupId)) {
            if (urls?.MITER_CORNER_PRODUCT_ID === mark?.productSubGroupId)
                dimensions = `Size ~ <br/> L1 x L2 x H`;
            else
                dimensions = `Size ~ <br/> L x H)`;
        }
        else if (urls?.WIDTH_HEIGHT_GROUP.includes(mark?.groupId))
            dimensions = `Size ~ <br/> W x H`;
        else if (urls?.DIAMETER_GROUP.includes(mark?.groupId))
            dimensions = `Size ~ <br/> Dia`;
        else
            return null;

        return (
            dimensions
        );
    };

    const renderProductDetail = (mark, prodItem) => {
        let dimensions = "";

        if (urls?.LENGTH_NO_OF_SLOTS_GROUP.includes(mark?.groupId)) {
            if (urls?.LENGTH1_LENGTH2_SLOTS_PRODUCT.includes(mark?.productSubGroupId))
                dimensions = `${getVariantValue(urls.LENGTH_1, prodItem)} x ${getVariantValue(urls.LENGTH_2, prodItem)} x ${getVariantValue(urls.NO_OF_SLOTS, prodItem)}`;
            else if (urls?.CURVED_LENGTH_PRODUCT_ID.includes(mark?.productSubGroupId))
                dimensions = `${getVariantValue(urls.ARC_LENGTH, prodItem)} x ${getVariantValue(urls.NO_OF_SLOTS, prodItem)} x ${getVariantValue(urls.END_CAPS, prodItem)}`;
            else
                dimensions = `${getVariantValue(urls.LENGTH, prodItem)} x ${getVariantValue(urls.NO_OF_SLOTS, prodItem)} x ${getVariantValue(urls.END_CAPS, prodItem)}`;
        }
        else if (urls?.LENGTH_HEIGHT_GROUP.includes(mark?.groupId)) {
            if (urls?.MITER_CORNER_PRODUCT_ID === mark?.productSubGroupId)
                dimensions = `${getVariantValue(urls.LENGTH_1, prodItem)} x ${getVariantValue(urls.LENGTH_2, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
            else if (urls?.CURVED_LINEARBAR_GRILL_PRODUCT_ID === mark?.productSubGroupId)
                dimensions = `${getVariantValue(urls.ARC_LENGTH, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
            else
                dimensions = `${getVariantValue(urls.LENGTH, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
        }
        else if (urls?.WIDTH_HEIGHT_GROUP.includes(mark?.groupId))
            dimensions = `${getVariantValue(urls.WIDTH, prodItem)} x ${getVariantValue(urls.HEIGHT, prodItem)}`;
        else if (urls?.DIAMETER_GROUP.includes(mark?.groupId))
            dimensions = `${getVariantValue(urls.DIAMETER, prodItem)}`;
        else
            return null;
        return (
            dimensions
        );
    };

    const getTagRefValue = (prodItem) => {
        const standard = prodItem?.productItemVariants?.find(
            filterItem => urls?.TAG_REF_CONSTANT.includes(filterItem?.variantId)
        )?.variantValue;
        if (standard) return standard;
        const fallback = prodItem?.productItemVariants?.find(
            filterItem => filterItem?.variantName?.toLowerCase().includes("tag")
        )?.variantValue;
        return fallback || "";
    };

    const getOtherRefValue = (prodItem) => {
        const standard = prodItem?.productItemVariants?.find(
            filterItem => urls?.OTHER_REF_CONSTANT?.includes(filterItem?.variantId)
        )?.variantValue;
        if (standard) return standard;
        const fallback = prodItem?.productItemVariants?.find(
            filterItem => filterItem?.variantName?.toLowerCase()?.includes("other")
        )?.variantValue;
        return fallback || "";
    };

    // Order data provides unitPrice directly on the product item - use it as the primary source.
    const getUnitPriceValue = (prodItem) => {
        const price = Number(prodItem?.unitPrice) || 0;
        return Number(price.toFixed(2));
    };

    // Order data provides lpoQuantity directly on the product item - use it as the primary source.
    const getQuantity = (prodItem) => {
        const variantQty = prodItem?.productItemVariants?.find(
            filterItem => urls?.QUANTITY_CONSTANT.includes(filterItem?.variantId)
        )?.variantValue;
        return Number(
            prodItem?.lpoQuantity ?? prodItem?.quoteQuantity ?? variantQty ?? prodItem?.quantity ?? 0
        );
    };

    // Prefer the order's own totalPrice per line item; fall back to unitPrice * qty only if missing.
    const getRowTotal = (prodItem) => {
        if (prodItem?.totalPrice !== undefined && prodItem?.totalPrice !== null) {
            return Number(prodItem.totalPrice) || 0;
        }
        return parseFloat((getUnitPriceValue(prodItem) * getQuantity(prodItem)).toFixed(2)) || 0;
    };

    const getMarkSubtotal = (mark) => {
        return mark?.productItems?.reduce((sum, prodItem) => {
            return sum + getRowTotal(prodItem);
        }, 0) || 0;
    };

    const getAngleValue = (prodItem) =>
        prodItem?.productItemVariants?.find(filterItem => urls?.ANGLE.includes(filterItem?.variantId))?.variantValue || "";

    const shouldShowAngleColumn = (mark) =>
        mark?.productItems?.some((prodItem) =>
            prodItem?.productItemVariants?.some((variant) => urls?.ANGLE.includes(variant?.variantId))
        );

    const DAMPER_WIDTH_HEIGHT_GROUPS = [
        urls.COMBINATION_FIRE_SMOKE_GROUP_ID,
        urls.FIRE_DAMPER_GROUP_ID,
        urls.STEEL_CONTROL_DAMPER,
        urls.DUCT_ACCESS_DOORS,
    ];

    const handlePrint = () => {
        window.print();
    };

    useEffect(() => {
        const userProf = getStorageData();
        const userProfId = userProf?.userCompanyId;
        const distributorUrl = distributorList?.find(item => item?.id === userProfId)
        setDistributorImage({ distributorUrl: distributorUrl, userProf: userProf })
    }, [distributorList])

    const netPrice = markDetails?.reduce((total, mark) => {
        return parseFloat((total + getMarkSubtotal(mark)).toFixed(2));
    }, 0) || 0;

    const netPriceVal = Number(orderPDFDetails?.data?.netPrice) || netPrice;
    const specialCharges = Number(orderPDFDetails?.data?.specialCharges) || 0;

    const taxAmount = (() => {
        const data = orderPDFDetails?.data;
        if (!data) return 0;
        if (data?.tax > 0) return data.tax * 1;
        if (data?.taxPercentage > 0) return (netPrice + specialCharges) * (data.taxPercentage * 1 / 100);
        return 0;
    })();
    const freightCharges = Number(orderPDFDetails?.data?.freightCharges) || 0;
    const customDutyPercentage = Number(orderPDFDetails?.data?.customDutyPercentage) || 0;
    const clearanceChargesPercentage = Number(orderPDFDetails?.data?.clearanceChargesPercentage) || 0;

    const totalExworksPrice = netPriceVal + specialCharges;

    const customDutyValue = orderPDFDetails?.data?.customDuty
        ? Number(orderPDFDetails?.data?.customDuty)
        : ((totalExworksPrice + freightCharges) * (customDutyPercentage / 100));

    const clearnceValue = orderPDFDetails?.data?.clearanceCharges
        ? Number(orderPDFDetails?.data?.clearanceCharges)
        : ((totalExworksPrice + freightCharges + customDutyValue) * (clearanceChargesPercentage / 100));

    const totalLandedCost = totalExworksPrice + freightCharges + customDutyValue + clearnceValue;
    const salesMarginValue = totalLandedCost * 1

    const grandTotal = Number(orderPDFDetails?.data?.grandTotal) || (taxAmount + salesMarginValue);


    const showTaxRow = (orderPDFDetails?.data?.tax > 0 || orderPDFDetails?.data?.taxPercentage > 0);
    const showGrandTotalRow = grandTotal > 0;

    return (
        <>

            <div className="container">
                <div className="row">
                    <div className="col-12 text-end">
                        <div className="print-btn-container">
                            <button onClick={() => handlePrint()} className="btn pdf-print-btn my-2">Export to PDF</button>
                        </div>
                    </div>
                    <div className="col-12">
                        <table className="bg-white page">
                            <thead>
                                <tr>
                                    <td className="boder-none p-0">
                                        <div className="page-header position-relative">
                                            <table className="quotation-summary-pdf-table-head w-100">
                                                <tr>
                                                    <th className="text-start pt-0 pl-0 position-relative">
                                                        <img className="w-100" src={distributorImage?.userProf?.userType === 2 ? distributorImage?.distributorUrl?.headerUrl : headerImage} />
                                                        <div className="quotation-text">ORDER</div>
                                                    </th>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </thead>

                            <tbody className="page-content">
                                <tr>
                                    <td className="boder-none">
                                        <div className="page">
                                            <table className="customer-details-table">
                                                <tbody>
                                                    <tr>
                                                        <td className="w-50 border-right">
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Customer <span className="float-right">:</span></td>
                                                                        <td>{customerObj?.data?.customerName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Address <span className="float-right">:</span></td>
                                                                        <td>{displayDetails?.customerAddress}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact Person <span className="float-right">:</span></td>
                                                                        <td>{displayDetails?.contactPerson}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact # <span className="float-right">:</span></td>
                                                                        <td>{displayDetails?.phone}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>

                                                        <td className="w-50">
                                                            <table className="w-100">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Order Ref <span className="float-right">:</span></td>
                                                                        <td>{orderPDFDetails?.data?.orderReference}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Date <span className="float-right">:</span></td>
                                                                        <td>{formatDate(displayDetails?.createdAt, "")}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Customer Email <span className="float-right">:</span></td>
                                                                        <td>{displayDetails?.emailAddress}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Sales Eng <span className="float-right">:</span></td>
                                                                        <td>{salesEngObj?.firstName + " " + salesEngObj?.lastName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Contact <span className="float-right">:</span></td>
                                                                        <td>{listData?.data?.phone}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="border-top" colspan="2">
                                                            <table>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="w-12">Project<span className="float-right">:</span></td>
                                                                        <td colspan="4">{projectObj?.data?.projectName}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="w-100 mt-1 mb-1 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-0"> Dear Sir/Madam, <br />
                                                            We thank you for your enquiry and are pleased to submit our proposal as follows:
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            {markDetails?.map((mark, index) => {
                                                const markSubTotal = getMarkSubtotal(mark);
                                                return (<>
                                                    <table className="product-table">
                                                        <thead>
                                                            <tr>
                                                                <td className="border-right-none" colSpan="4">
                                                                    <span><strong>MODEL :</strong></span> <strong>{mark?.productName}</strong>
                                                                </td>
                                                                <td colSpan="3" className="text-end border-left-none">
                                                                    <span><strong>PRODUCT :</strong></span> <strong>{mark?.groupName}</strong>
                                                                </td>
                                                            </tr>
                                                            {renderSpecifications(mark)}
                                                            <tr>
                                                                <th className="text-center">#</th>
                                                                <th className="text-center">Tag Ref.</th>
                                                                <th className="text-center" dangerouslySetInnerHTML={{ __html: renderProductHeading(mark) }}></th>
                                                                <th className="text-center">Qty</th>
                                                                <th className="text-center white-space-nowrap">Unit Price</th>
                                                                <th className="text-center">Total Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                mark?.productItems?.map((prodItem, prodIndex) => {
                                                                    const quantity = getQuantity(prodItem);
                                                                    const unitPrice = getUnitPriceValue(prodItem);
                                                                    const rowTotal = getRowTotal(prodItem);

                                                                    let filterVariant = variantData?.find(varItem => varItem.markId === prodItem?.quoteProductId)?.result
                                                                    let includePrint = filterVariant?.data?.filter(item => item.includeInPrint === true)
                                                                    return (
                                                                        <tr>
                                                                            <td className="text-center">{prodIndex + 1}</td>
                                                                            <td className="text-center">{getTagRefValue(prodItem)}</td>
                                                                            <td className="text-center">{renderProductDetail(mark, prodItem)}</td>
                                                                            <td className="text-center">{quantity}</td>
                                                                            <td className="text-end">{FormatValueDecimal(CurrencyConvertion(unitPrice, displayDetails?.conversionRate, currencyDetail))}</td>
                                                                            <td className="text-end">{FormatValueDecimal(CurrencyConvertion(rowTotal, displayDetails?.conversionRate, currencyDetail))}</td>

                                                                        </tr>
                                                                    )
                                                                })}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colspan="5" className="text-end"><strong>Sub Total:</strong></td>
                                                                <td colspan="1" className="text-end"><strong>{FormatValueDecimal(CurrencyConvertion(markSubTotal, displayDetails?.conversionRate, currencyDetail))} </strong></td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </>)
                                            })}
                                            <table className="net-price-table w-100 mt-5px">
                                                <tbody>
                                                    <tr>
                                                        <td className="quote-amount-words">
                                                            <strong className="quote-amount-words-title">Amount in words</strong>
                                                            <span className="quote-amount-words-value">{numberToWords(CurrencyConvertion(grandTotal, displayDetails?.conversionRate, currencyDetail), currencyDetail)}</span>
                                                        </td>
                                                        <td className="quote-summary-cell">
                                                            <table className="quote-summary-inner">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="quote-summary-item">
                                                                            <span>Net Price</span><span className="ml-1">:</span>
                                                                            <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(netPrice, displayDetails?.conversionRate, currencyDetail))}</span>
                                                                        </td>
                                                                    </tr>
                                                                    {specialCharges > 0 && (
                                                                        <tr>
                                                                            <td className="quote-summary-item">
                                                                                <span>Color Charges</span><span className="ml-1">:</span>
                                                                                <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(specialCharges, displayDetails?.conversionRate, currencyDetail))}</span>
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                    {showTaxRow && (<tr>
                                                                        <td className="quote-summary-item">
                                                                            <span>Taxes / VAT {displayDetails?.tax > 0 ? "" : "@ " + displayDetails?.taxPercentage + "%"}</span><span className="ml-1">:</span>
                                                                            <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(taxAmount, displayDetails?.conversionRate, currencyDetail))}</span>
                                                                        </td>
                                                                    </tr>)}
                                                                    {showGrandTotalRow && (<tr>
                                                                        <td className="quote-summary-item quote-summary-item--grand">
                                                                            <span>Grand Total</span><span className="ml-1">:</span>
                                                                            <span className="ml-1">{currencyDetail?.shortCode} {FormatValueDecimal(CurrencyConvertion(grandTotal, displayDetails?.conversionRate, currencyDetail))}</span>
                                                                        </td>
                                                                    </tr>)}
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="terms-conditions-table w-100 mt-5px border-0">
                                                <thead>
                                                    <tr>
                                                        <th className="text-start" colspan="2"> Terms & Conditions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td className="text-start">Payment Terms
                                                            <span className="float-right">:</span>
                                                        </td>
                                                        <td className="text-start"> {displayDetails?.paymentTerms || paymentTermsList?.find(item => item?.id === displayDetails?.paymentTermId)?.paymentDescription}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Delivery Terms <span className="float-right">:</span></td>
                                                        <td className="text-start"> {displayDetails?.deliveryTerms || deliveryTermsList?.find(item => item?.id === displayDetails?.deliveryTermId)?.deliveryDescription
                                                            || displayDetails?.destination}
                                                            {countryList?.find(country => country?.id === displayDetails?.destinationCountryId)?.name
                                                                && (countryList?.find(country => country?.id === displayDetails?.destinationCountryId)?.name)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Delivery Period <span className="float-right">:</span></td>
                                                        <td className="text-start">As per the project requirement</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Validity <span className="float-right">:</span></td>
                                                        <td className="text-start"> {displayDetails?.quoteValidity} days from the date hereof and thereafter subject to our written
                                                            confirmation.</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-start">Warranty <span className="float-right">:</span></td>
                                                        <td className="text-start"> Goods manufactured by Jersey Manufacturing carry a standard warranty of 12
                                                            months from the date of supply,
                                                            against all manufacturing defects, subject to our warranty policy - (can be provided on
                                                            request).</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="w-100 mt-1 mb-1 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="border-0"> We once again thank you for the opportunity to order for your requirement. Please feel free to contact us in case of any clarification. <br />
                                                            Thanking you and assuring you our best attention and services at all times.
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td className="border-0 pt-3 fs-13"> For, Jersey Manufacturing for Airconditioning Products
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table className="signature-table w-100 mt-1 mb-1 border-0 mt-5">
                                                <tbody>
                                                    <tr>
                                                        <td className="text-center border-0"> Sales Engineer
                                                        </td>
                                                        <td className="text-center border-0">  Divisional manager</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colspan="9" className="border-0 pb-0">
                                        <div className="page-footer-space"></div>
                                        <div className="page-quote-footer w-100">
                                            <table className="footer-quote-logo-table w-100 border-0">
                                                <tbody>
                                                    <tr>
                                                        <td className="text-start border-0 pl-0">Order Ref # : {orderPDFDetails?.data?.orderReference}</td>
                                                        <td className="text-end border-0">{moment(new Date()).format("DD-MMM-YYYY hh:mm A")}</td>
                                                        <td className="text-end border-0 pr-40">QR/DR-N/2021 RDO</td>
                                                        {/* <td className="text-end border-0 pr-40">Page 1 of 7</td>  */}
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                            <tfoot>
                                <tr>
                                    <td colspan="9" className="border-0">
                                        <div className="page-footer w-100">
                                            <table className="footer-logo-table w-100 border-0">
                                                <tbody>
                                                    <tr className="border-top">
                                                        <th className="text-start pl-0 pr-0 border-0 pt-0 pb-0" colSpan="9">
                                                            <img src={distributorImage?.userProf?.userType === 2 ? distributorImage?.distributorUrl?.footerUrl : footerImage} alt="Footer Logo" className="footer-logo w-100" />
                                                        </th>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>

                        </table>
                    </div>
                </div>
            </div>
            <NewTermsAndConditions distributorImage={distributorImage} />
        </>


    );
};

export default OrderPDFNewDetail;
